export const setFavoritesHeader = (count) => {
  const favoritesHeaderLink = document.querySelector(`.js--favoritesHeaderLink`);
  if (!favoritesHeaderLink) {
    return;
  }
  favoritesHeaderLink.dataset.count = !+count ? `` : count;
};
